import dayjs, { Dayjs } from 'dayjs';

export interface DisabledTimeConfig {
  disabledHours?: () => number[];
  disabledMinutes?: (hour: number) => number[];
}

interface CampaignDateTimeRange {
  startDate: Dayjs | null;
  startTime: Dayjs | null;
  endDate: Dayjs | null;
  endTime: Dayjs | null;
}

const createNumberRange = (length: number): number[] =>
  Array.from({ length }, (_, index) => index);

const toDateTime = (date: Dayjs, time: Dayjs | null): Dayjs =>
  date
    .hour(time?.hour() ?? 0)
    .minute(time?.minute() ?? 0)
    .second(0)
    .millisecond(0);

export const getMinimumCampaignStartDate = (current: Dayjs = dayjs()): Dayjs =>
  current.add(1, 'day').startOf('day');

export const isBeforeMinimumCampaignStartDate = (date: Dayjs): boolean =>
  date.isBefore(getMinimumCampaignStartDate(), 'day');

export const isBeforeCampaignEndDate = (
  date: Dayjs,
  startDate: Dayjs | null,
): boolean => {
  const minimumStartDate = getMinimumCampaignStartDate();
  const boundaryDate =
    startDate && !startDate.isBefore(minimumStartDate, 'day')
      ? startDate.startOf('day')
      : minimumStartDate;

  return date.isBefore(boundaryDate, 'day');
};

export const getCampaignEndDisabledTime = (
  endDate: Dayjs | null,
  startDate: Dayjs | null,
  startTime: Dayjs | null,
): DisabledTimeConfig => {
  if (
    !endDate ||
    !startDate ||
    !startTime ||
    !endDate.isSame(startDate, 'day')
  ) {
    return {
      disabledHours: () => [],
      disabledMinutes: () => [],
    };
  }

  const startHour = startTime.hour();
  const startMinute = startTime.minute();

  return {
    disabledHours: () => createNumberRange(startHour),
    disabledMinutes: (hour: number) =>
      hour === startHour ? createNumberRange(startMinute + 1) : [],
  };
};

export const isCampaignEndAfterStart = ({
  startDate,
  startTime,
  endDate,
  endTime,
}: CampaignDateTimeRange): boolean => {
  if (!startDate || !endDate) return true;

  return toDateTime(endDate, endTime).isAfter(
    toDateTime(startDate, startTime),
    'minute',
  );
};
